import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

type Theme = {
	isSmall?: boolean;
};

interface Props {
	theme: Theme;
}

const Wrapper = styled('div')`
	margin: ${(props: Props) => props.theme.isSmall ? '0' : '0 45px'};
	min-width: 0;
	font-family: HelveticaNeue, sans-serif;
	color: ${hexToRgba(NewStyleColor.Black, 80)};
	word-break: break-all;
	word-break: break-word;
`;

const Name = styled('div')`
	margin-bottom: ${(props: Props) => props.theme.isSmall ? '5px' : '15px'};
	font-size: ${(props: Props) => props.theme.isSmall ? '17px' : '34px'};
	line-height: 1.2;
`;

const Position = styled('div')`
	font-weight: ${(props: Props) => props.theme.isSmall ? '700' : '400'};
	font-size: ${(props: Props) => props.theme.isSmall ? '12px' : '15px'};
	line-height: 1.3;
`;

const Contact = styled('div')`
	min-height: ${(props: Props) => props.theme.isSmall ? '14px' : '20px'};
	font-size: ${(props: Props) => props.theme.isSmall ? '12px' : '15px'};
	line-height: ${(props: Props) => props.theme.isSmall ? '14px' : '20px'};
	color: ${hexToRgba(NewStyleColor.Black, 40)};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export {
	Wrapper,
	Name,
	Position,
	Contact,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/UserInfo/styles.ts